import { Box, Toolbar } from '@mui/material';
import { StyledContentContainer } from '../style';
import PatientMemo from './PatientMemo';
import NursingRecords from './NursingRecords';
import Advertisement from './Advertisement';
import Precautions from './Precautions';
import Allergy from './Allergy';

export const inputInformationWidth = { xs: 340, xl: 530 };

interface Props {
  coachRefA: any;
  coachRefB: any;
}

const InputInformation = ({ coachRefA, coachRefB }: Props) => {
  return (
    <Box component="aside" width={inputInformationWidth}>
      <Advertisement />

      <StyledContentContainer>
        <Allergy />
        <Precautions />
        <PatientMemo coachRef={coachRefA} />
        <NursingRecords coachRef={coachRefB} />
      </StyledContentContainer>
    </Box>
  );
};

export default InputInformation;
